module.exports = {"id":"dp4_3l3q7","text":"Supporting Wellbeing","instructions":"Regularly adapting digital habits can help individuals respond to changing technologies and wellbeing risks.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l3q7-a1","text":"True","score":3.7},{"id":"dp4_3l3q7-a2","text":"Not sure","score":1.3},{"id":"dp4_3l3q7-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l3q7.json
// module id = 1256
// module chunks = 41